import {
  SELECT_DOMAIN_FOR_CERTIFICATION,
  CURRENT_DOMAIN_FOR_CERTIFICATION,
  SELECT_COURSE_FOR_CERTIFICATION,
  CURRENT_CERTIFICATION_ID,
  SELECT_ACTIVE_SERVICE_DOMAIN,
  DELETE_SERVICE_DOMAIN,
  CLEAR_ALL_SERVICE_DOMAIN,
  GET_RESPONSE_SERVICE_DOMAIN,
  REQUEST_SERVICE_DOMAIN,
  ERROR_GET_RESPONSE,
  RESPONsE_SERVICE_DOMAIN,
  CLEAR_RESPONSE,
  SERVICE_DOMAIN_TAB,
  SERVICE_DOMAIN_TAB_RESET,
} from "./type";

const initialState = {
  selected_domain: [],
  current_domain: {},
  selected_course: [],
  certicicate_id: "",
  selected_service_domain: [],
  response_service_domain: {},
  error_get_response: null,
  loading_service_domain: false,
  selected_domain_tab: "100",
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_DOMAIN_FOR_CERTIFICATION:
      return {
        ...state,
        selected_domain: action.payload,
      };
    case CURRENT_DOMAIN_FOR_CERTIFICATION:
      return {
        ...state,
        current_domain: action.payload,
      };
    case SELECT_COURSE_FOR_CERTIFICATION:
      return {
        ...state,
        selected_course: action.payload,
      };
    case CURRENT_CERTIFICATION_ID:
      return {
        ...state,
        certicicate_id: action.payload,
      };
    case SELECT_ACTIVE_SERVICE_DOMAIN:
      const isDuplicate = state.selected_service_domain.some(
        (obj) => obj.inputId === action.payload.inputId
      );
      if (!isDuplicate) {
        return {
          ...state,
          selected_service_domain: [
            ...state.selected_service_domain,
            action.payload,
          ],
        };
      }
      return state;
    case REQUEST_SERVICE_DOMAIN:
      return {
        ...state,
        loading_service_domain: true,
        error_get_response: null,
      };
    case GET_RESPONSE_SERVICE_DOMAIN:
      // Create an object to track unique inputIds
      const uniqueInputIds = {};

      // Filter out duplicates and store the unique objects
      const uniquePayload = action.payload
        ? action.payload.filter((obj) => {
            if (!uniqueInputIds[obj.inputId]) {
              uniqueInputIds[obj.inputId] = true;
              return true;
            }
            return false;
          })
        : [];
      return {
        ...state,
        selected_service_domain: uniquePayload,
        loading_service_domain: false,
        error_get_response: null,
      };
    case ERROR_GET_RESPONSE:
      return {
        ...state,
        loading_service_domain: false,
        error_get_response: action.payload,
      };
    case DELETE_SERVICE_DOMAIN:
      const updatedArray = state.selected_service_domain.filter(
        (obj) => obj.inputId !== action.payload.inputId
      );

      return {
        ...state,
        selected_service_domain: updatedArray,
      };
    case CLEAR_ALL_SERVICE_DOMAIN:
      return {
        ...state,
        selected_service_domain: [],
      };

    case RESPONsE_SERVICE_DOMAIN:
      return {
        ...state,
        response_service_domain: action.payload,
      };

    case CLEAR_RESPONSE:
      return {
        ...state,
        response_service_domain: {},
      };
    case SERVICE_DOMAIN_TAB:
      return {
        ...state,
        selected_domain_tab: action.payload,
      };
    case SERVICE_DOMAIN_TAB_RESET:
      return {
        ...state,
        selected_domain_tab: "",
      };
    default:
      return state;
  }
}
